import React from 'react';

import {
  Col,
} from "react-bootstrap";

const ExperienceCard = ({ data }) => {
  return (
    // use auto-width columns so cards size to their content and stay centered
    <Col xs="auto">
      <div className="pb-3 px-2 text-center experience-card">
        <div className="experience-logo bg-white mb-2">
          <img src={data.companylogo} alt="" />
        </div>
        <p className="lead mb-0">
          {data.company}
          <br />
          {data.role}
          <br />
          {data.date}
        </p>

      </div>
    </Col>
  );
}

export default ExperienceCard;